import * as React from 'react';

import { PropertyInfoSubSectionViewModel } from 'models';

import { AmenityBody } from './internals/amenity-body';
import { AmenityListItem } from './amenity-list-item';
import { AmenityTitle } from './internals/amenity-title';

export interface AmenityDescriptionProps {
  section: PropertyInfoSubSectionViewModel;
  index: number;
  category: string;
}

export const AmenityDescription: React.FunctionComponent<AmenityDescriptionProps> = ({ index, category, section }) => (
  <div className="policies__section--text all-y-padding-three" key={`${category}-${index}`}>
    <AmenityTitle category={category} title={section.title} />
    {section.descriptions &&
      section.descriptions.map((text, sectionIndex) => (
        <AmenityBody key={`amenity-body-${sectionIndex}`} text={text} index={sectionIndex} category={category} />
      ))}
    <ul className="uitk-type-list-300 all-t-margin-two amenities-room__list">
      {section.body &&
        section.body.map((item, sectionIndex) => (
          <AmenityListItem key={`amenity-${category}-${sectionIndex}`} item={item} type={category} />
        ))}
    </ul>
  </div>
);
